import {
  Module, ActionTree, MutationTree, GetterTree
} from 'vuex';
import { cardNum } from '@/services/http';
import { readCookie, writeCookie, removeCookie } from '@/tools/tools';
import { CardState } from './types';
import { RootState } from '../types';
/**
 * getters
 */
// export const getters: GetterTree<CardState, RootState> = {
//   addresslist: (state: CardState) => state.cardnumber,
// };

/**
 * mutations
 */
export const mutations: MutationTree<CardState> = {
  // 购物车变化
  CARDNUMBER(state: CardState, payload: number) {
    state.cardnumber = payload;
    writeCookie('cardNum', state.cardnumber);
  },
  // 修改购物车
  UPDATECARD(state: CardState, payload: number) {
    state.cardnumber = payload;
  },
  SETCARDLIST(state: CardState, payload: []) {
    state.cardList = payload;
    writeCookie('cardlist', state.cardList);
  }
};

/**
 * actions
 */
export const actions: ActionTree<CardState, RootState> = {
  async setCardNum({ commit }) {
    const res: any = await cardNum({
      companyId: 1
    });
    commit('CARDNUMBER', res.data.data);
  }
};
/**
 * state
 */
export const state: CardState = {
  cardnumber: readCookie('cardNum') ? readCookie('cardNum') : 0,
  cardList: readCookie('cardlist') ? readCookie('cardlist') : []
};
const namespaced: boolean = true;

export const card: Module<CardState, RootState> = {
  namespaced,
  state,
  // getters,
  mutations,
  actions
};
